import * as React from 'react';
import * as _ from 'lodash';
import { Dispatch, connect } from 'react-redux';
import { IReportState, IApplicationState, AppActionCreators, ReportActionCreators, ICenterCLCScoresResponse } from '@nkr/store/index';
import { IClcScoresSummary, IUser } from '@nkr/models/index';
import { CsvExportParams, ProcessCellForExportParams } from 'ag-grid-community';
import CenterCLCScoresGrid from './center-cls-scores-grid';

import 'ag-grid-community/dist/styles/ag-theme-bootstrap.css';

interface IOwnProps {
    centerId: number,
    isAdmin: boolean
}

interface IStateProps {
    user: IUser,
    reports: IReportState
}

interface IDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    getCenterCLCScoresReport: () => Promise<ICenterCLCScoresResponse>
}

type TProps = IStateProps & IDispatchProps & IOwnProps

interface IState {
    list: IClcScoresSummary[]
}

class CenterCLCScoresReport extends React.Component<TProps, IState> {
    readonly state: IState = {
        list: []
    }

    componentDidMount = () => {
        this.getData();
    }

    getData = () => {
        this.props.showLoading('Getting report data, one moment please...').then(() => {
            this.props.getCenterCLCScoresReport()
                .then((response: ICenterCLCScoresResponse) => {
                    this.setState({
                        list: response.data.results
                    });

                    this.props.hideLoading();
                }).catch((ex) => {
                    alert('An error occured while loading report data');
                    this.props.hideLoading();
                });
        });
    };

    handleExport = () => {
        let params: CsvExportParams = {
            columnGroups: true,
            fileName: `clc-scores.csv`,
            processCellCallback: (params: ProcessCellForExportParams) => {
                let colDef = params.column.getColDef();

                if (colDef.colId == 'centerAlias') {
                    if (params.node.data.centerAlias == '') {
                        return 'Totals';
                    }
                }

                return params.value;
            }
        };
    }

    render = () => {
        return (
            <>
                <CenterCLCScoresGrid
                    list={this.state.list}
                    // reportUser={this.props.user}
                    centerId={this.props.centerId}
                    isAdmin={this.props.isAdmin}
                />
            </>
        );
    }
}

const mapStateToProps = (appState: IApplicationState): IStateProps => {
    return {
        user: appState.app.user,
        reports: appState.reports
    }
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            dispatch(AppActionCreators.hideLoading());
        },
        getCenterCLCScoresReport: () => {
            return dispatch(ReportActionCreators.getCenterCLCScoresReport());
        }
    }
}

export default connect<IStateProps, IDispatchProps, IOwnProps>(
    mapStateToProps,
    mapDispatchToProps)(CenterCLCScoresReport);